import { useI18n, type MessageKey } from '@ecom/i18n';
import { Badge, type BadgeTone } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

import type { ProductStatus } from '../types';

const TONE_BY_STATUS: Record<ProductStatus, BadgeTone> = {
  draft: 'neutral',
  active: 'good',
  inactive: 'critical',
};

const LABEL_KEY_BY_STATUS: Record<ProductStatus, MessageKey> = {
  draft: 'merchant.products.status.draft',
  active: 'merchant.products.status.active',
  inactive: 'merchant.products.status.inactive',
};

export function ProductStatusBadge({ status }: { status: ProductStatus }): ReactElement {
  const { t } = useI18n();
  return <Badge tone={TONE_BY_STATUS[status]}>{t(LABEL_KEY_BY_STATUS[status])}</Badge>;
}
